import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { isStaticAsset } from './static-asset.util';

/** Marge avant expiration au-delà de laquelle un refresh préemptif est déclenché. */
const REFRESH_MARGIN_MS = 30 * 60 * 1000;

/** Verrou : un seul refresh préemptif en vol à la fois. */
let refreshInFlight: Promise<void> | null = null;

/**
 * Rafraîchit le jeton en tâche de fond si son expiration approche, sans jamais bloquer
 * ni modifier la requête courante (équivalent simplifié de l'intercepteur préemptif de Front).
 */
export function tokenRefreshInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  // Un fichier statique (locale, image) ne porte pas de session : sortir avant d'injecter
  // AuthService, dont la construction déclencherait une requête qui repasserait ici (NG0200)
  if (isStaticAsset(req.url)) return next(req);

  const auth = inject(AuthService);
  const expiry = auth.accessTokenExpiry();

  if (
    expiry !== null &&
    refreshInFlight === null &&
    !req.url.includes('/connect/token') &&
    Date.now() >= expiry.getTime() - REFRESH_MARGIN_MS
  ) {
    refreshInFlight = auth
      .refresh()
      .catch(() => undefined) // le 401 réactif de auth.interceptor prendra le relais si besoin
      .finally(() => (refreshInFlight = null));
  }

  return next(req);
}
